import { IntuneUser } from "../Intune/intune-user.model";

export class ActivityLog {
  id!: number;
  user_id!: string;
  action!: string;
  resource_type!: string;
  resource_id?: string | null;
  metadata?: any | null;
  ip_address?: string | null;
  user_agent?: string | null;

  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;

  user?: IntuneUser | null;

  constructor(data?: Partial<ActivityLog>) {
    Object.assign(this, data);
    this.user = data?.user ? new IntuneUser(data.user) : null;
  }
}